<div header="Verification Code" class="align-items-center">
    <div class="col-12 mb-3 p-0">
        <div class="w-full flex flex-column gap-3 pb-3">
            <div class="flex gap-1">
                Please Enter Verification Code:
            </div>
        </div>
        <input class="p-inputtext p-component" type="number" pInputText [(ngModel)]="value" maxlength="4"/>  
    </div>
   
    <div class="flex justify-content-end gap-2">
        <p-button label="cancel" severity="secondary" (click)="closeDialog()" />
        <p-button [disabled]="!value" label="ok" (click)="confirm()" />
    </div>
</div>